'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { useAppDispatch } from '@/store';
import { setPreviousRoute } from '@/store/slices/navigationSlice';

const RouteTracker = () => {
  const pathname = usePathname();
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(setPreviousRoute(pathname));
    };
  }, [pathname, dispatch]);

  return null;
};

export default RouteTracker;
